/** Build-time identity of this deployment; empty on local and non-Vercel builds, and wherever the defines do not exist, such as the test runner. */
export const DEPLOY = {
	sha: typeof __PANDAS_DEPLOY_SHA__ === "undefined" ? "" : __PANDAS_DEPLOY_SHA__.slice(0, 12),
	deploymentId: typeof __PANDAS_DEPLOYMENT_ID__ === "undefined" ? "" : __PANDAS_DEPLOYMENT_ID__,
	ref: typeof __PANDAS_DEPLOY_REF__ === "undefined" ? "" : __PANDAS_DEPLOY_REF__,
} as const;
